import ProgressTest from './component';

import _routes from './routes';

export const routes = _routes;

export default ProgressTest;



// WEBPACK FOOTER //
// ./containers/Group/ProgressTest/index.js